/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2} from "@mui/material";
import icono_localizacion from '../../../../Recursos/Ic_location.svg'
import icono_llamada from '../../../../Recursos/icono_llamada_contacto.svg'
import icono_correo from '../../../../Recursos/icono_correo_contacto.svg'
import icono_nit from '../../../../Recursos/icono_nit_black_contacto.svg'
import Tarjeta_Contacto_Home from "../Tarjetas/Tarjeta_Contacto_Home";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";


const Lista_Contactos_Home = () => {
    const {sCell, sTab} = useResponsive()

    return (
        <Grid2
            container
            justifyContent={'center'}
            alignItems={'flex-start'}

            size={12}>

            <Grid2 container size={{xs: 12, sm: 6, md: 3}}
                   sx={{borderRight: sCell ? 0 : `2px solid #000`, pt: 3, px: 2}}>
                <Tarjeta_Contacto_Home
                    icono_correo={icono_localizacion}
                    contacto={'Carrera 28 A No. 17 - 15 Oficina 202 Edificio Antonella'}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 6, md: 3}}
                   sx={{borderRight: sCell ? 0 : `2px solid #000`, pt: 3, px: 2}}>
                <Tarjeta_Contacto_Home
                    icono_correo={icono_llamada}
                    contacto={'(602) 73-520-83 / +57 315-540-4983'}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 6, md: 3}}
                   sx={{borderRight: sCell ? 0 : `2px solid #000`, pt: 3, px: 2}}>
                <Tarjeta_Contacto_Home
                    icono_correo={icono_correo}
                    contacto={'secretariasonar@gmail.com'}/>
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 6, md: 3}}
                   sx={{borderRight: sTab ? `2px solid #000` : 0, pt: 3, px: 2}}>
                <Tarjeta_Contacto_Home
                    icono_correo={icono_nit}
                    contacto={'900849614-1'}/>
            </Grid2>

        </Grid2>
    )

}
export default Lista_Contactos_Home;